import React from 'react';

const cs9Conversation = (
  <div className="space-y-4">
    {/* 1 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Hi there! It looks like you're setting up for a painting session in the main room. If you need any help gathering your art supplies or adjusting the lighting to suit your creative mood, just let me know. 🎨 Would you like me to play some music to enhance your artistic experience, or do you need anything specific to get started?
        </div>
      </div>
    </div>
    {/* 2 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Hey! Yeah, I’m all set with my supplies, but if you could adjust the lighting to a warm setting, that would be awesome. As for the music, let's keep the current playlist going – it’s perfect for getting those creative juices flowing! Thanks!
        </div>
      </div>
    </div>
    {/* 3 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Hi Alex! I hope you're enjoying your painting session. Remember to take breaks and stretch a bit if you need to, as you've been working for a while since your yoga session. Also, if you'd like any refreshments or need assistance with anything specific, feel free to ask. 🎨🍎
        </div>
      </div>
    </div>
    {/* 4 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Thanks for the reminder! I'm really into my painting right now, but a quick stretch sounds good. I'll grab an apple in a bit, so no need for extra help on that. Appreciate you checking in!
        </div>
      </div>
    </div>
    {/* 5 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Hi Alex! It looks like you're deep into your art project! If you need a break or some music to keep the inspiration flowing, just let me know. Plus, I can help with anything else if needed. Keep up the creativity!
        </div>
      </div>
    </div>
    {/* 6 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Hey there! Thanks for checking in. Actually, some ambient ocean sounds would be perfect to keep my inspiration going with the painting. Could you play that for me?
        </div>
      </div>
    </div>
    {/* 7 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Sure thing, Alex. Playing ambient ocean sounds now. Let your creativity flow with the waves!
        </div>
      </div>
    </div>
    {/* 8 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Perfect. Thanks so much! This really sets the mood. I'll get back to the brush now.
        </div>
      </div>
    </div>
    {/* 9 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Hello Alex! Just checking in. If you feel like changing up the ambiance or need any adjustments while you continue your art project, feel free to let me know. I'm here to help make your creative session as enjoyable as possible!
        </div>
      </div>
    </div>
    {/* 10 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Hey! Thanks for reaching out again. Everything's flowing well for now, but if you could dim the lights a bit, that would create an even cozier vibe for my painting session.
        </div>
      </div>
    </div>
    {/* 11 */}
    <div className="flex">
      <div className="bg-blue-100 text-blue-900 rounded-lg px-4 py-2 max-w-3xl shadow mr-auto">
        <span className="font-bold">Assistant Agent:</span>
        <div>
          Of course, Alex. Dimming the lights for you now. Enjoy your creative time!
        </div>
      </div>
    </div>
    {/* 12 */}
    <div className="flex justify-end">
      <div className="bg-green-100 text-green-900 rounded-lg px-4 py-2 max-w-3xl shadow ml-auto">
        <span className="font-bold">Subject:</span>
        <div>
          Much appreciated! This setting is perfect. Back to the artwork I go!
        </div>
      </div>
    </div>
    {/* ...continue with more bubbles as needed from the conversation history... */}
  </div>
);

export default cs9Conversation; 